import React										from 'react';
import {Route, Routes, useParams}					from 'react-router-dom';

import Header										from '../Header/Header';
import MobileLines									from './MobileLines';

import {useAppSelector}								from '../app/hooks';

import LANGUAGE										from '../ressources/language';


export default function MainMobileLines() {
	const mobileLines = useAppSelector(state => state.mobileLines.data);
	const lang = useAppSelector(state => state.settings.lang);

	const params = useParams();
	const TEXTE = LANGUAGE(lang);

	return (
		<div className={'globalContainerWithHeader'}>
			<Header
				menuValue={params['*']}
				title={TEXTE.mobileLines.title}
				badgeText={mobileLines.length}
			/>

			<Routes>
				<Route path={'/'} element={<MobileLines />} />
				<Route path={'/:idLine'} element={<MobileLines />} />
			</Routes>
		</div>
	);
}
